import React from 'react';

function LinearProgress(): React.JSX.Element {
  return (
    <div
      className="linearProgress"
      role="progressbar"
      aria-label="Loading"
      aria-busy="true"
    >
      <div className="linearProgress--bar-one" />
      <div className="linearProgress--bar-two" />
    </div>
  );
}

export default LinearProgress;
